import type { WrapRootElementBrowserArgs, WrapRootElementNodeArgs } from 'gatsby';
import { SnackbarProvider } from 'notistack';
import React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { CartProvider, ShopifyProvider, useShopifyCookies } from '@shopify/hydrogen-react';
import type { CountryCode, LanguageCode } from '@shopify/hydrogen-react/storefront-api-types';

import { cartFragment } from './src/shared/shopify/graphql/fragments';
import theme from './src/shared/theme';

// import { StoreProvider } from './src/state/store';

export default ({ element }: WrapRootElementBrowserArgs | WrapRootElementNodeArgs) => {
  // const isSiteFramed = serverData?.isSiteFramed;
  const isBrowser = typeof window !== 'undefined';

  // const contentfulPreviewEnabled = process.env.GATSBY_CONTENTFUL_PREVIEW_ENABLED === 'true' && !(typeof window === 'undefined');

  const AppProviders = () => {
    return <>
      {/* <HydrateStateProvider> */}
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        <SnackbarProvider maxSnack={1} autoHideDuration={5000} variant='success' classes={{
          containerRoot: 'snackbar-container-root',
        }} disableWindowBlurListener={true} anchorOrigin={{ horizontal: 'center', vertical: 'top' }}>
          {/* <ContentfulLivePreviewProvider debugMode={false} targetOrigin={'https://app.contentful.com'} enableLiveUpdates={contentfulPreviewEnabled} enableInspectorMode={contentfulPreviewEnabled} locale="en-US"> */}
          {element}
          {/* </ContentfulLivePreviewProvider> */}
        </SnackbarProvider>
      </ThemeProvider>
      {/* </HydrateStateProvider> */}
    </>
  }

  return (
    <ShopifyCookieProvider>
      <ShopifyProvider
        storefrontId={process.env.GATSBY_SHOPIFY_SHOP_ID as string}
        storeDomain={process.env.GATSBY_SHOPIFY_CHECKOUT_DOMAIN as string}
        storefrontToken={process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN as string}
        storefrontApiVersion={process.env.GATSBY_SHOPIFY_STOREFRONT_API_VERSION as string}
        countryIsoCode={process.env.GATSBY_SHOPIFY_COUNTRY_ISO_CODE as CountryCode}
        languageIsoCode={process.env.GATSBY_SHOPIFY_LANGUAGE_ISO_CODE as LanguageCode}
      >
        {isBrowser ? (
          <CartProvider
            countryCode={process.env.GATSBY_SHOPIFY_COUNTRY_ISO_CODE as CountryCode}
            languageCode={process.env.GATSBY_SHOPIFY_LANGUAGE_ISO_CODE as LanguageCode}
            cartFragment={cartFragment}
          >
            <AppProviders />
          </CartProvider>
        ) : <AppProviders />
        }
      </ShopifyProvider>
    </ShopifyCookieProvider>
  )
}

const ShopifyCookieProvider = ({ children }: { children: React.ReactNode }) => {
  // TODO: integrate with consent popup
  const hasUserConsent = true;
  // console.log('Cookies provider', { hasUserConsent, domain: process.env.GATSBY_SHOPIFY_COOKIE_DOMAIN, checkoutDomain: process.env.GATSBY_SHOPIFY_CHECKOUT_DOMAIN })
  // useShopifyCookies({ hasUserConsent, domain: process.env.GATSBY_SHOPIFY_COOKIE_DOMAIN, checkoutDomain: process.env.GATSBY_SHOPIFY_CHECKOUT_DOMAIN });
  useShopifyCookies({ hasUserConsent, domain: process.env.GATSBY_SHOPIFY_COOKIE_DOMAIN });

  return <>{children}</>
}